/**
 * Reaproveita, para cada item, a linha de MESMA IDENTIDADE que ja esta na tela.
 *
 * A grade desenha uma linha por objeto. Montar objetos novos a cada carga fazia ela
 * apagar e redesenhar todas as linhas, e a lista piscava mesmo quando nada tinha
 * mudado (relato de 08/10/2026, em "Acesso ao painel"). Com o mesmo objeto, so o campo
 * que mudou se redesenha.
 *
 * O montador recebe a linha antiga (ou nada, quando a pessoa e nova) e tem de
 * reescrever TODOS os campos dela - um campo preenchido so "quando houver" ficaria com
 * o valor da carga anterior.
 */
export function reuseRows(current, items, keyOf, build) {
    const before = new Map();
    for (const row of current ?? []) {
        before.set(String(row.identity), row);
    }
    return items.map((item) => build(item, before.get(String(keyOf(item)))));
}
//# sourceMappingURL=reuse-rows.js.map